import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo";
import LegalDocument from "@/components/legal/LegalDocument";
import TermsContent from "@/components/legal/TermsContent";

export const Route = createFileRoute("/terms")({
  component: TermsOfUse,
  head: () =>
    seoHead({
      title: "Terms of Use | Lutely",
      description:
        "The terms that govern how artists and fans use Lutely to sell, buy and own music.",
      canonicalPath: "/terms",
    }),
});

function TermsOfUse() {
  return (
    <LegalDocument title="Terms of Use">
      <TermsContent />
    </LegalDocument>
  );
}
